@if (!hide) {
  <div class="native-navigation-bar" [class.d-none]="hasNoLinks">
    @for (item of navigationMenu | navigationItems : menuArea.BOTTOM_NATIVE_BAR | async; track item; let last = $last) {
      <ng-container *displayMenuItem="item.key">
        <a
          class="native-bar-link"
          [navigationElement]="item"
          [extendedRouterLink]="item.path"
          [pageId]="item.pageId"
          extendedRouterLinkActive="active-link">
          @if (item.icon) {
            <lib-icon [icon]="item.icon" size="20"></lib-icon>
          }
          @if (item.iconMedia) {
            <lib-svg-icon [url]="item.iconMedia?.uri "></lib-svg-icon>
          }
          {{ item.title | translate }}
        </a>
      </ng-container>
    }
  </div>
}
